// PageHeader — reusable header voor Settings + Tech pages.
//
// Layout: [title + hint links] [meta rechts: pills, buttons].
// Mobiele variant stackt meta onder de hint.
//
// Geen state intern. Geen polling. Geen fetches.

import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  hint?: ReactNode;   // mag <code> bevatten via JSX
  meta?: ReactNode;   // dirty-badge / git-pill / counters etc.
  actions?: ReactNode; // buttons (Annuleren, Opslaan, Logs…)
}

export function PageHeader({ title, hint, meta, actions }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="page-header__main">
        <h1 className="page-header__title">{title}</h1>
        {hint && <p className="page-header__hint">{hint}</p>}
      </div>
      {(meta || actions) && (
        <div className="page-header__meta">
          {meta}
          {actions}
        </div>
      )}
    </header>
  );
}
